export const environment = {
    usersSoporte: ["soporte-clientes@informax.cl"],
    orgsDesarrollo: ["DESARROLLO"],
    inactivity: {
        initInactivity: 900,
        timeoutInactivity: 10,
        respawnInactivity: 10,
        countdown: 15
    },
    cognito: {
      userPoolID: "us-east-1_p96Mdgx7Q",
      clientId: "1ub8jaboi60i2q9hjias8uai7p"
    },
    apis: {
      dataSentinel: "https://hn0k3erqyf.execute-api.us-east-1.amazonaws.com/DEV",
      userAccess: "https://yaufclr91m.execute-api.us-east-1.amazonaws.com/DEV/"
    }
}